import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

interface Props {
    rejectLabel: string;
    approveLabel: string;
    approvingLabel: string;
    approving: boolean;
    onReject: () => void;
    onApprove: () => void;
}

export function EstimateDecisionActions({ rejectLabel, approveLabel, approvingLabel, approving, onReject, onApprove }: Props) {
    return (
        <Stack direction="row" spacing={1} justifyContent="flex-end" data-testid="estimate-decision-actions">
            <Button variant="outlined" color="error" onClick={onReject} data-testid="estimate-decision-actions-reject">
                {rejectLabel}
            </Button>
            <Button variant="contained" sx={{ color: 'white' }} onClick={onApprove} disabled={approving} data-testid="estimate-decision-actions-approve">
                {approving ? approvingLabel : approveLabel}
            </Button>
        </Stack>
    );
}
